import React, { useState, useEffect } from 'react'
import * as moment from 'moment';
import { Form, Formik, Field } from 'formik';

import { connect, useDispatch, useSelector } from 'react-redux';
import RadioButton from 'web/components/RadioButton';
import Button from 'web/components/Button';
import Timmer from 'web/components/Timmer';
import AlertModal from 'web/components/AlertModal';
import { FORMAT, BIDFORMAT } from 'web/components/utils/dateOfBirthValidation';
import CheckIcon from 'web/assets/svg/CheckIcon'
import { pickupRequest, rejectRequest } from 'redux/actions/myClaims';
import star from 'web/assets/images/star.png';
import information from 'web/assets/images/information.png';
import styled from 'styled-components'
import { TrackDetail, TrackBox, NoRecordFound } from './trackDetailTypeOneStyled'

// import Rating from '@material-ui/lab/Rating';
import Box from '@material-ui/core/Box';

const TrackDetailTypeReceivedClaim = ({ response, index, items, callBackFun, canceledOrderCallBack, downloadCallBack, btnEnable }) => {
    const dispatch = useDispatch();
    const [note, setNote] = useState('')

    const [acceptState, setAcceptState] = useState(false)
    const [rejectState, setRejectState] = useState(false)

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('/');
    const toggleModal = () => setModal(!modal);
    let title = '';

    const acceptArr = [
        {
            value: 'Used',
            label: 'I will pick them up',
        },
        {
            value: 'New',
            label: 'Throw them away',
        },
        {
            value: 'no_preferences',
            label: 'Other',
        },
    ];
    const rejectArr = [
        {
            value: 'Used',
            label: 'Quantity (I just dont agree)',
        },
        {
            value: 'New',
            label: 'Quality (Pallets are not mine)',
        },
        {
            value: 'Quality',
            label: 'Quality (Not supported evedience of issue)',
        },
        {
            value: 'Other',
            label: 'Other',
        },
    ];
    const token = localStorage.getItem('token');
    useEffect(() => {
    }, []);

    const acceptCreditHandler = async () => {
        if (token === null) {
            setModalContent('Please Sign In again.');
            setModalLink('/');
            toggleModal();
        } else {
            let data =
                {
                    id: "608bcfdc54cd246db9bfbaad",
                    orderId: "OD161977538536",
                    returnInstruction: "Old Pallets",
                    returnPickUpDate: "2021-04-30",
                    isPickedUpIssuesPallet: true  // when seller want to pick up pallets  otherwise false
                }

            let response = await dispatch(pickupRequest(data, token));
            if (response.status === 'SUCCESS') {
                if (response.payload.length !== 0) {
                }
            } else {
            }
        }
    }
    const rejectHandler = async () => {
        if (token === null) {
            setModalContent('Please Sign In again.');
            setModalLink('/');
            toggleModal();
        } else {
            let data =
                {
                    id: "608bcfdc54cd246db9bfbaad",
                    orderId: "OD161977538536",
                }

            let response = await dispatch(rejectRequest(data, token));
            if (response.status === 'SUCCESS') {
                if (response.payload.length !== 0) {
                }
            } else {
                setModalContent(response.message);
                setModalLink('');
                toggleModal();
            }
        }
    }

    const acceptRadio = () => {
        return <div className='row mx-0'>
            <div className='col-12 '>
                <div className='text-left'>
                    <p style={{ marginBottom: '14px', marginRight: '15px' }}>
                        What would seller like buyer to do?</p>
                </div>
                <div className=''>
                    {acceptArr &&
                        acceptArr.map((value, index) => (
                            <div className='mr-5' key={index}>
                                <RadioButton
                                    name='advanceCondition'
                                    id={value.value}
                                    defaultValue={acceptArr[0].value}
                                    onBlur={() => { }}
                                    onSelect={(e) => {
                                    }}
                                    label={value.label}
                                />
                            </div>
                        ))}

                </div>
            </div>
        </div>
    }

    const rejectRadio = () => {
        return <div className='row mx-0'>
            <div className='col-12 '>
                <div className='text-left'>
                    <p style={{ marginBottom: '14px', marginRight: '15px' }}>
                        What would seller like buyer to do?</p>
                </div>
                <div className=''>
                    {rejectArr &&
                        rejectArr.map((value, index) => (
                            <div className='mr-5' key={index}>
                                <RadioButton
                                    name='advanceCondition'
                                    id={value.value}
                                    defaultValue={rejectArr[0].value}
                                    onBlur={() => { }}
                                    onSelect={(e) => {
                                    }}
                                    label={value.label}
                                />
                            </div>
                        ))}

                </div>
            </div>
        </div>
    }
    return (<>
        <TrackDetail>
            <TrackBox key={index}>
                <div>
                    <p className="colorfull">Order ID</p>
                    <p>12345678</p>
                </div>
                <div>
                    <p className="colorfull">Claim Type</p>
                    <p>Quality</p>
                </div>
                <div>
                    <p className="colorfull">Status</p>
                    <p>Pending</p>
                </div>
                <div>
                    <div className="flexWrapper">
                        <p className="colorfull">Total Quantity</p>
                        <p>10 Lots</p>
                    </div>
                    <div className="flexWrapper">
                        <p className="colorfull">Claimed QuantityD</p>
                        <p>2 Lots</p>
                    </div>
                </div>
                <div>
                    <div className="flexWrapper">
                        <p className="colorfull">Total Cost</p>
                        <p>1000 USD</p>
                    </div>
                    <div className="flexWrapper">
                        <p className="colorfull">Claimed Cost</p>
                        <p>400 USD</p>
                    </div>
                </div>
                <div>
                    <p className="colorfull">Uploaded</p>
                    <p>12345678</p>
                </div>

                {acceptState && acceptRadio()}
                {rejectState && rejectRadio()}

                {(!acceptState && !rejectState) && <><Button
                    type='app-green-button submitBtn'
                    handleClick={() => {
                        setAcceptState(true)
                    }}>
                    Accept wilt credit
               </Button>
                    <Button
                        type='app-green-button submitBtn'
                        handleClick={() => {
                            setRejectState(true)
                        }}>
                        Reject
               </Button></>
                }
            </TrackBox>

        </TrackDetail>
        <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            content={modalContent}
            link={modalLink}
        />
    </>
    )
};

export default TrackDetailTypeReceivedClaim;


const Timer = styled.div`
    width: 88px;
    flex: unset !important;
`

const TrackStatus = styled.div`
    font-size: 15px;
    flex: unset !important;
    font-family: "latobold";
    margin-bottom: 5px;
`
